
:host {
	display: grid;
	grid-template-columns: 2fr 1fr;
	grid-template-rows: auto auto;
	grid-column-gap: 2rem;
}

:host smoothly-input-checkbox[name="hasOwner"],
:host > smoothly-form smoothly-tabs {
	flex-basis: 100%;
}
